<template>
  <main>
    <!-- START : Loader & Error Message -->
    <WCSpinner v-if="!loadFailedError && loading" position="center" size="xl" />
    <div
      class="font-size-xl d-flex flex-column align-items-center justify-content-center"
      v-else-if="loadFailedError"
    >
      <h1 class="text-primary mb-4">{{ $t('oops') }}!</h1>
      <p>{{ $t('weCouldntFindThisItem') }}</p>
      <router-link :to="'/'" class="btn btn-outline-primary">{{ $t('returnHome') }}</router-link>
    </div>
    <!-- END : Loader & Error Message -->
    <template v-else-if="item">
      <h1 class="sr-only" tabindex="-1" ref="focusFirst">{{ $t('productDetailsPage') }}</h1>
      <platform-renderer>
        <template v-slot:onMobile>
          <ProductDetailPageMobile :item="item" />
        </template>

        <template v-slot:onDesktop>
          <ProductDetailPageDesktop :item="item" />
        </template>
      </platform-renderer>
      <RecommendedProducts :productId="$route.params.id" />
    </template>
  </main>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import PlatformRenderer from '@/modules/platform/components/PlatformRenderer';
import FocusMixin from '@/mixins/FocusMixin';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import TrackableEventConstants from '@/constants/TrackableEventConstants';
import AnalyticsService from '@/services/analytics.service';
import { defineComponent } from 'vue';
import ProductDetailPageMobile from './ProductDetailPageMobile.vue';
import ProductDetailPageDesktop from './ProductDetailPageDesktop.vue';
import RecommendedProducts from './components/RecommendedProducts/RecommendedProducts.vue';

export default defineComponent({
  components: {
    ProductDetailPageMobile,
    ProductDetailPageDesktop,
    PlatformRenderer,
    RecommendedProducts,
    WCSpinner,
  },
  mixins: [FocusMixin], // Mixin for main content focus via routing
  data() {
    return {
      item: null,
      loading: false,
      loadFailedError: null,
    };
  },
  created() {
    this.fetchProductDetails();
  },
  methods: {
    /**
     * Method to get product details
     */
    async fetchProductDetails() {
      this.loading = true;
      this.loadFailedError = null;
      try {
        const response = await axios.get(`/api/i/${this.$route.params.id}`);

        this.item = response.data;
        AnalyticsService.track(TrackableEventConstants.ItemViewed, {
          item: this.item,
          customerId: this.getUser?.sub,
        });
      } catch (error) {
        this.item = null;
        this.loading = false;
        this.loadFailedError = error;
        console.error(error);
      }
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters({
      getUser: 'user/getUser',
    }),
  },
  watch: {
    /**
     * Method to update the product details on product id change in route
     */
    // eslint-disable-next-line func-names
    '$route.params.id': function() {
      this.fetchProductDetails();
    },
  },
});
</script>
